// extracted by mini-css-extract-plugin
module.exports = {"formButtonGroup":"P73hJ","openInviteCta":"_113jk","inviteContainer":"_2I38L"};